<script lang="ts">
  import { onDestroy } from 'svelte'
  import { getBase64 } from '../../helpers'
  import { preview_image } from '../../store'

  import Tooltip from '../../../../../../ui/Tooltip/Tooltip.svelte'

  let files: File[];

  const clearFiles = (): void => {
    files = []
    $preview_image.base64 = ''
    $preview_image.name = ''
  }

  const openImage = () => {
    const image = new Image()
    const base64 = $preview_image.base64
    
    image.src = `${base64.includes('data') ? base64 : `data:image/jpg;base64,${base64}`}`
    
    window
      .open('about:blank')
      .document
      .write(image.outerHTML)
  }

  onDestroy(clearFiles)
</script>

<div class="file-form">
  <div class="title-wrapper">
    <div class="title">Изображение превью</div>

    <Tooltip tooltip="Это картинка, которую видно в Ленте">
      <i class="icon-question" />
    </Tooltip>
  </div>

  {#if $preview_image.base64}
    <div class="uploaded-file" on:click={openImage}>
      <div>{$preview_image.name}</div>
      <i class="icon-newsline-search-clear" on:click={clearFiles} />
    </div>
  {:else}
    <label for="upload-photo">
      <div class="file-button">
        <i class="icon-upload" />
        <div>Загрузить фото</div>
      </div>
    </label>
  {/if}

  <input 
    bind:files 
    accept="image/png, image/gif, image/jpeg"
    type="file" 
    name="photo" 
    id="upload-photo"
    on:change={async () => $preview_image = await getBase64(files)}
  />
</div>

<style lang="scss">
  .title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    i {
      color: #5A5F6D99;
      font-size: 14px;
      margin-left: 7px;
    }
  }

  .file-form {
    margin-bottom: 16px;
  }

  .title {
    color: #30333D;
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
  }

  .uploaded-file {
    background-color: #E0E8F6;  
    padding: 12px;
    box-sizing: border-box;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    color: #5A5F6D;

    i {
      margin-left: 16px;
      cursor: pointer;
      font-size: 10px;
      color: #2B50ED;
    }
  }

  label {
    cursor: pointer;
    border: 1px solid #B6C8F9;
    padding: 31px;
    display: flex;
    justify-content: center;
    align-items: center;

    .file-button {
      background-color: #E0E8F6;
      color: #2B50ED;
      font-weight: 600;
      line-height: 20px;
      border-radius: 50px;
      display: flex;
      padding: 6px 16px;
      box-sizing: border-box;
      font-size: 14px;

      i {
        margin-right: 8px;
      }
    }
  }

  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
</style>